import React from 'react';
import {changeToSlug} from '@helper/string.helper';
import LoadingDetailLink from './LoadingDetailLink';

export default function LinkServicePackageDetail({news = {}, children}) {
    const slug = changeToSlug(news.news_title);

    return (
        <LoadingDetailLink href={slug ? `/goi-dich-vu-chi-tiet/${slug}` : ''}>{children}</LoadingDetailLink>
    );
}
